module.exports = __webpack_public_path__ + "img/DP.ee460ea4.png";